import { 
  LeaderboardUserEntry, 
  UserLeaderboardStats, 
  EventCompletionResult,
  LeaderboardEvent,
  CompleteEventParams,
  LeaderboardEventWithUserStatus,
} from '@crypto-trading/common/browser';
import { ApiClientManager } from '@/utils/api-client-factory';

/**
 * Leaderboard API functions
 */

/**
 * Get leaderboard (top users by points)
 */
export const getLeaderboard = async (limit: number = 100): Promise<LeaderboardUserEntry[]> => {
  return ApiClientManager.getLeaderboardClient().getLeaderboard(limit);
};

/**
 * Get user's leaderboard stats
 */
export const getUserStats = async (userId: string): Promise<UserLeaderboardStats> => {
  return ApiClientManager.getLeaderboardClient().getUserStats(userId);
};

/**
 * Get user's rank in the leaderboard
 */
export const getUserRank = async (userId: string): Promise<number | null> => {
  return ApiClientManager.getLeaderboardClient().getUserRank(userId);
};

/**
 * Complete an event for a user
 */
export const completeEvent = async (params: CompleteEventParams): Promise<EventCompletionResult> => {
  return ApiClientManager.getLeaderboardClient().completeEvent(params);
};

/**
 * Get all active events
 */
export const getActiveEvents = async (): Promise<LeaderboardEvent[]> => {
  return ApiClientManager.getLeaderboardClient().getActiveEvents();
};

/**
 * Get active events with per-user completion status
 */
export const getUserEvents = async (userId: string): Promise<LeaderboardEventWithUserStatus[]> => {
  return ApiClientManager.getLeaderboardClient().getUserEvents(userId);
};

